<div class="sh-facet">
  @if (showLabel) {
    <div class="sh-facet__label sh-facet-placeholder-background sh-facet-placeholder-title"></div>
  }
  <ul class="sh-facet__values sh-form-check-list">
    @for (_ of [].constructor(4); track _; let i = $index) {
      <li class="sh-form-check sh-facet__values__value sh-form-check-list__item">
        <div
          class="sh-form-check sh-form-check-list__item__check sh-facet-placeholder-background sh-facet-placeholder-value"
          [style]="'animation-delay: '+ i/8 + 's;'"
        ></div>
      </li>
    }
  </ul>
</div>
